/**
 * Static editorial content for T&S Ivory — image URLs curated by the design agent
 * (Unsplash + Pexels). Indian brand context, brunette/black hair, neutral interiors.
 */

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1546877625-cb8c71916608?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

export const ABOUT_IMAGE =
  "https://images.pexels.com/photos/819836/pexels-photo-819836.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";

export const FEATURED_IMAGE =
  "https://images.unsplash.com/photo-1612196808827-9ff25cb6137a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxuZXV0cmFsJTIwaW50ZXJpb3IlMjBtaW5pbWFsJTIwc3VubGlnaHR8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85";

export const SERVICES = [
  {
    slug: "hair",
    title: "Hair",
    line: "01",
    description:
      "Cuts, colour, gloss, and slow, sculptural treatments — built around how your hair actually behaves in this city.",
    items: [
      { name: "Editorial Cut", price: "₹ 4,800" },
      { name: "Single Process Colour", price: "₹ 7,500" },
      { name: "Balayage / Hand Painted", price: "₹ 14,000" },
      { name: "Glaze & Gloss", price: "₹ 3,800" },
      { name: "Olaplex Restorative", price: "₹ 5,600" },
    ],
    image:
      "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGhlYWx0aHklMjBoYWlyJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc4MjExNTg4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "nails",
    title: "Nails",
    line: "02",
    description:
      "A minimal nail studio, conceived as a quiet ritual rather than a service. Tone-on-tone palettes, deep cuticle work, slow finishes.",
    items: [
      { name: "Signature Manicure", price: "₹ 1,800" },
      { name: "Russian-Style Pedicure", price: "₹ 3,200" },
      { name: "Sheer Glass Finish", price: "₹ 2,400" },
      { name: "Gel Removal & Repair", price: "₹ 1,200" },
    ],
    image:
      "https://images.unsplash.com/photo-1772983166346-93afb9898264?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwbmV1dHJhbCUyMG5haWxzfGVufDB8fHx8MTc4MjExNTg4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "makeup",
    title: "Makeup",
    line: "03",
    description:
      "Skin-first makeup, designed to look like the most rested version of you. Editorial finishes for film, evening, and the everyday.",
    items: [
      { name: "Day to Evening", price: "₹ 5,200" },
      { name: "Editorial / Campaign", price: "₹ 12,000" },
      { name: "Brow Architecture", price: "₹ 1,800" },
      { name: "Lash Tint & Lift", price: "₹ 2,800" },
    ],
    image:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBiZWF1dHklMjBwb3J0cmFpdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "bridal",
    title: "Bridal",
    line: "04",
    description:
      "Wedding day beauty without the costume. A small atelier of stylists, designing the bride you already are — only slightly more lit.",
    items: [
      { name: "The Engagement Look", price: "₹ 22,000" },
      { name: "The Bridal Atelier (Day)", price: "₹ 65,000" },
      { name: "The Three-Day Edit", price: "₹ 1,40,000" },
      { name: "Pre-Wedding Skin Programme", price: "₹ 38,000" },
    ],
    image:
      "https://images.unsplash.com/photo-1606143412458-acc5f86de897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBiZWF1dHklMjBwb3J0cmFpdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "essentials",
    title: "Essentials",
    line: "05",
    description:
      "Consulted skincare and haircare rituals, curated by the Ivory team. Subtraction over addition — fewer, better, every day.",
    items: [
      { name: "Skin Consultation (60 min)", price: "₹ 3,800" },
      { name: "Scalp Reset", price: "₹ 4,400" },
      { name: "Hand & Foot Ritual", price: "₹ 2,600" },
      { name: "Wedding Skin Programme", price: "₹ 28,000" },
    ],
    image:
      "https://images.unsplash.com/photo-1585945037805-5fd82c2e60b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxvcmdhbmljJTIwc2tpbmNhcmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4MjExNTg4OXww&ixlib=rb-4.1.0&q=85",
  },
];

// Gallery — varied heights for masonry
export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1546877625-cb8c71916608?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGhlYWx0aHklMjBoYWlyJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc4MjExNTg4OXww&ixlib=rb-4.1.0&q=85", caption: "Slow hair, soft daylight" },
  { url: "https://images.unsplash.com/photo-1772983166346-93afb9898264?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwbmV1dHJhbCUyMG5haWxzfGVufDB8fHx8MTc4MjExNTg4OXww&ixlib=rb-4.1.0&q=85", caption: "Sheer milk manicure" },
  { url: "https://images.unsplash.com/photo-1774477178005-bff823e43be8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxuZXV0cmFsJTIwaW50ZXJpb3IlMjBtaW5pbWFsJTIwc3VubGlnaHR8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85", caption: "The Bandra atelier" },
  { url: "https://images.unsplash.com/photo-1612196808827-9ff25cb6137a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxuZXV0cmFsJTIwaW50ZXJpb3IlMjBtaW5pbWFsJTIwc3VubGlnaHR8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85", caption: "Linen, travertine, late light" },
  { url: "https://images.unsplash.com/photo-1634665810235-011d663754e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcGElMjB0ZXh0dXJlJTIwbGluZW58ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85", caption: "Texture study" },
  { url: "https://images.unsplash.com/photo-1528458909336-e7a0adfed0a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcGElMjB0ZXh0dXJlJTIwbGluZW58ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85", caption: "Beige on beige" },
  { url: "https://images.unsplash.com/photo-1533933269825-da140ad3132f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxlZGl0b3JpYWwlMjBiZWF1dHklMjBwb3J0cmFpdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85", caption: "Editorial portrait" },
  { url: "https://images.pexels.com/photos/17022652/pexels-photo-17022652.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940", caption: "A study in movement" },
  { url: "https://images.unsplash.com/photo-1608068811588-3a67006b7489?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxvcmdhbmljJTIwc2tpbmNhcmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4MjExNTg4OXww&ixlib=rb-4.1.0&q=85", caption: "Essentials, distilled" },
  { url: "https://images.pexels.com/photos/282892/pexels-photo-282892.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=940", caption: "Folded linen" },
  { url: "https://images.pexels.com/photos/16400335/pexels-photo-16400335.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940", caption: "Studio motion" },
  { url: "https://images.unsplash.com/photo-1606143412458-acc5f86de897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBiZWF1dHklMjBwb3J0cmFpdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85", caption: "Quiet portrait" },
];

export const TESTIMONIALS = [
  {
    quote:
      "I have left other salons looking expensive. I left T&S Ivory looking like myself, just slightly more rested. I cannot explain the difference, but it is the only one that matters.",
    author: "Ananya M.",
    location: "Bandra, Mumbai",
  },
  {
    quote:
      "The colourist remembered, eight months later, that my hair lifts copper in the monsoon. We adjusted. It is hard to overstate how rare that is.",
    author: "Devika S.",
    location: "Returning client since 2022",
  },
  {
    quote:
      "Our wedding photographs do not look styled. They look like the day we lived. That, alone, is the review.",
    author: "Mira & Rohan",
    location: "Wedding · February 2024",
  },
];

export const PHILOSOPHY = {
  eyebrow: "01 — Philosophy",
  title: "Quiet luxury. Personal care. Intentional beauty.",
  body: [
    "We are not a salon in the conventional sense. We are a small atelier of hairdressers, colourists, manicurists and skin specialists, working out of a single room in Bandra.",
    "Our work is slow on purpose. The light is soft on purpose. Everything you see, hear, and feel inside the room is part of the treatment.",
  ],
};

export const SERVICE_TIMES = ["Morning", "Afternoon", "Evening"];

export const PRESS = [
  "Vogue India",
  "Harper's Bazaar",
  "Elle",
  "Tatler Asia",
  "Conde Nast Traveller",
  "Architectural Digest",
  "Grazia",
  "Verve",
];
